import React from 'react';
import Icon from '../../../components/AppIcon';

const WorkoutProgress = ({
  totalExercises = 0,
  completedExercises = 0,
  totalSets = 0,
  completedSets = 0,
  duration = 0
}) => {
  const progress = totalExercises > 0 ? (completedExercises / totalExercises) * 100 : 0;
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  const stats = [
    {
      icon: 'Dumbbell',
      label: 'Exercises',
      value: `${completedExercises}/${totalExercises}`,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Layers',
      label: 'Sets',
      value: `${completedSets}/${totalSets}`,
      color: 'var(--color-accent)'
    },
    {
      icon: 'Clock',
      label: 'Duration',
      value: hours > 0 
        ? `${hours}h ${minutes}m` 
        : `${minutes}:${seconds?.toString()?.padStart(2, '0')}`,
      color: 'var(--color-success)'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Workout Progress
        </h3>
        <div className="text-right">
          <p className="text-2xl md:text-3xl font-bold data-text text-primary">
            {Math.round(progress)}%
          </p>
          <p className="text-xs caption text-muted-foreground">Complete</p>
        </div>
      </div>

      <div className="mb-6">
        <div className="relative h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-accent rounded-full transition-smooth"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 md:gap-4">
        {stats?.map((stat, index) => (
          <div 
            key={index}
            className="p-3 md:p-4 bg-muted rounded-lg hover-lift transition-smooth"
          >
            <div className="flex items-center gap-2 mb-2">
              <div 
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${stat?.color}15` }}
              >
                <Icon name={stat?.icon} size={16} color={stat?.color} strokeWidth={2} />
              </div>
              <p className="text-xs caption text-muted-foreground">{stat?.label}</p>
            </div>
            <p className="text-lg md:text-xl font-bold data-text text-foreground">
              {stat?.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkoutProgress;